import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught:', error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: 48,
            textAlign: 'center',
            fontFamily: 'system-ui, -apple-system, sans-serif',
            color: 'var(--apx-text-primary)',
            background: 'var(--apx-bg-body)',
          }}
        >
          <h2 style={{ fontSize: 20, marginBottom: 12, color: '#dc2626' }}>
            Something went wrong
          </h2>
          <p style={{ fontSize: 14, color: 'var(--apx-text-secondary)', marginBottom: 24, maxWidth: 400, margin: '0 auto 24px' }}>
            {this.state.error?.message ?? 'An unexpected error occurred.'}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              padding: '8px 16px',
              borderRadius: 6,
              border: '1px solid var(--apx-border)',
              background: 'var(--apx-bg-input)',
              color: 'var(--apx-text-primary)',
              cursor: 'pointer',
              fontSize: 14,
            }}
          >
            Reload page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
